
import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Label } from '@/components/ui/label';

interface TopicFilterProps {
  value: string;
  onChange: (value: string) => void;
}

export const TopicFilter: React.FC<TopicFilterProps> = ({ value, onChange }) => {
  return (
    <div className="flex items-center space-x-2">
      <Label htmlFor="topic-filter" className="text-sm font-medium whitespace-nowrap">
        AI Type:
      </Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="w-40">
          <SelectValue placeholder="All AI Types" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All AI Types</SelectItem>
          <SelectItem value="guide">Guide AI</SelectItem>
          <SelectItem value="performance">Performance AI</SelectItem>
          <SelectItem value="trading_strategy">Trading Strategy AI</SelectItem>
          <SelectItem value="advisor">Advisor AI</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
